export default __webpack_public_path__ + "static/1-css-combinator-afc29184bdccf77f3e7ebd6b53912cf7.png";